export const DEFAULT_NEXT = '/dashboard'

export const PUBLIC_ROUTES = {
  HOME: '/',
  FORGOT: '/forgot',
  LOGIN: '/login',
  LOGOUT: '/logout',
  REGISTER: '/register',
  RESET: '/reset',
  SWITCHING: '/switching',
  NOT_FOUND: '*',
}

export const REGISTER_ROUTES = {
  GATEWAY: `${PUBLIC_ROUTES.REGISTER}/gateway`,
  GATEWAY_SUCCESS: `${PUBLIC_ROUTES.REGISTER}/gateway/success`,
  NEW_ACCOUNT: `${PUBLIC_ROUTES.REGISTER}/account`,
  ACCOUNT_SUCCESS: `${PUBLIC_ROUTES.REGISTER}/account/success`,
  ACCOUNT_ERROR: `${PUBLIC_ROUTES.REGISTER}/account/error`,
}
